/**
 * API endpoint constants for video meeting operations.
 *
 * These match the backend routes defined in client_api_urls.py.
 */

export const VIDEO_API = {
  MEETING_DETAILS: (meetingId: number | string) =>
    `/video/meeting/${meetingId}/`,
  JOIN_ROOM: "/video/room/join/",
  LEAVE_ROOM: "/video/room/leave/",
  VERIFY_ACCESS: (roomId: number) =>
    `/video/room/verify-access/?room_id=${roomId}`,
  HEARTBEAT: "/video/room/heartbeat/",
  ACTIVE_USERS: (roomId: number) =>
    `/video/room/active-users/?room_id=${roomId}`,
  LOG_ERROR: "/video/room/log-error/",
  TOGGLE_TRANSCRIPTION: "/video/room/transcription/toggle/",
  USER_MEETINGS: "/video/meetings/",
} as const;

export const QUERY_KEYS = {
  VIDEO_MEETING_DETAILS: "videoMeetingDetails",
  USER_MEETINGS: "userMeetings",
  VIDEO_MEETING_ACTIVE_USERS: "videoMeetingActiveUsers",
  VIDEO_ROOM_ACCESS: "videoRoomAccess",
} as const;
